import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function WhoIsForSection() {
  const points = ['Quieres dejar de depender de referidos', 'Necesitas más control sobre tu flujo de prospectos', 'Reclutas personas, pero pocas se activan', 'Quieres seguimiento documentado', 'Quieres crecer con una estructura duplicable', 'Trabajas en seguros y quieres una comunidad que entienda tu realidad'];
  return <section className="py-14 px-4 sm:px-6 lg:px-8 bg-brand-white relative border-t border-brand-gold/10" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-144">
          <h2 className="font-heading font-bold text-3xl md:text-4xl uppercase tracking-tight text-brand-text mb-8 text-center" data-id="element-145">
            Esto es para ti si…
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-146">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start bg-brand-charcoal p-6 rounded-lg border border-brand-gold/10 shadow-sm" data-id="element-147">
                <CheckCircle2Icon className="w-6 h-6 text-brand-gold shrink-0 mr-4 mt-0.5" data-id="element-148" />
                <span className="text-brand-text-muted text-lg" data-id="element-149">{point}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}